<template lang="html">
  <div style="min-height: 14.8rem;">
  
      <!-- 广告位 -->
     

      <ul >
        <template v-for="item in showList">
          
            <li  class="item game" @click="goDetail(item)">
           <div class="top-img icon-img" :style="item.homeRecommendUrl ? {backgroundImage: `url(${item.homeRecommendUrl})`} : {}"></div>
          <div class="bottom">
            <span class="small-img icon-img" :style="item.gameIcon ? {backgroundImage: `url(${item.gameIcon})`} : {}"></span>
            <div class="info">
              <p class="name">{{item.gameName}}</p>
              <p class="tags">{{item.tags ? item.tags : item.intro}}</p>
            </div>
            <span  class="btn-play" @click.stop="goPlay(item)"></span>
          </div>
          </li>
          
  
        
        </template>
      </ul>
  <a class="gomore" :href='"http://g.10086.cn?channel="+channel'>查看更多...</a>
  </div>
</template>

<script>
import Vue from 'vue'
import API from "../../api/api";
import { mapState, mapMutations } from 'vuex';
import $ from 'jquery';
import addClientEvent from "../../api/addClientEvent";

export default {
  name: "onlinePlay",
  data () {
    return {
      advertPic: '',
      advertUrl: '',
      isNeedLogin: '',
      channel: '',
      isHide: '',
      allList: [],
      showList: [],
      showIndex: 10,
      recommGame: [],
      subjectGame: [],
      channel: '',
      isHide: '',
      noDataText: ''
    }
  },
  props: ['homeShowIndex'],
  watch: {
    showIndex () {
      console.log('this.showIndex', this.showIndex)
      this.showList = this.allList.slice(0, this.showIndex)
      sessionStorage.showIndex = this.showIndex
    },
    homeShowIndex () {
      if (this.homeShowIndex) {
        console.log('this.homeShowIndex', this.homeShowIndex)
        this.showIndex = this.homeShowIndex
      }
    }
  },
  created () {
    this.channel = MG.utils.getQueryString('channel') ? MG.utils.getQueryString('channel') : ''
    this.isHide = MG.utils.getQueryString('isHide') ? MG.utils.getQueryString('isHide') : ''
  },
  computed: {
    ...mapState('os', ['gameList'])
  },
  mounted() {
    
    
    this.$emit('passScroller', 'home', this.$refs.homeScroller)
    if (this.gameList.length == 0) {
      this.init();
    } else {
      setTimeout (e => {
        this.allList = this.gameList
      }, 10)
    }
  },
  methods: {
    clickBanner () {
      if (this.isNeedLogin) {
        let url =  window.location.href
        window.location.href = 'https://passport.migu.cn/login?sourceid=206026&apptype=2&forceAuthn=false&isPassive=false&authType=DS&display=wap&callbackURL=' + url + '&logintype=2&pagestyle=1&backimage=1'
      } else {
        window.location.href = this.advertUrl
      }
    },
    goDetail(item) {
        console.log(item);
       
       window.location.href = 'http://www.migufun.com/miguplay/gamedetail/'+item.gameId+'/1?channel='+this.channel;
       return false;
    
    },
    goPlay (item) {
      console.log('item.........', item)
 
      window.location.href=`http://www.migufun.com/miguplay/gameplay/${item.gameId}/${item.gameName}/${item.packageName}/${item.portrait}/5?channel=${this.channel}`;
      return false;
    
    },
    goUrl (item) {
     
    },
    init () {
     
      this.getGameList()
    },
   
    getGameList() {
      if(localStorage.getItem('mg_521_list')){
        this.showList = JSON.parse(localStorage.getItem('mg_521_list'));
        return false;
      }
       this.showList = [{}]
      let glist = [600004508,600004511,600004512,600004509]
      
      
      glist.map((item,index)=>{
          console.log(index);
          this.gameId = item
            
        let param = {
          data: {
            'gameId': this.gameId,
            'clientType': '2',
           
          }
        }
        API.getGameDetail(param).then((resp) => {
          if (resp.data.returnCode === '000000') {
            console.log('getGameDetail......success', resp.data.resultData)
            
            
                Vue.set(this.showList,index,resp.data.resultData.gameInfoResp)
                let showList = JSON.stringify(this.showList);
                localStorage.setItem('mg_521_list',showList);
          
            }
          
          })
        
        
      });
     
    },
    getGameDetailNew(){
        
    },
    infinite(done) {
     
    },
    goDownload () {
      
    },
    
    refresh() {
     
    }
  }
}
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
  @import './../../assets/miguplay/css/onlinePlay.scss';
  .gomore {display: block; line-height:2rem;text-align: center; color: #27C127; text-decoration: none;font-size:0.4rem;}
</style>





// WEBPACK FOOTER //
// src/components/homeCompents/onlinePlay.vue